import { createSelector } from '@ngrx/store';

import { SlipId } from '../bet-generation/models';
import { UnderMinimumStakePreCheckError } from './errors/pre-check/under-minimum-stake-pre-check-error';
import { selectHasInsufficientMoneyError, selectSlipErrorsFactory } from './selectors';
import { isUnderMinimumStakeErrorPreCheck } from './services/utils/betslip-errors-utils';

export const selectLinearStakeErrorsFactory = (slipKey: SlipId) =>
    createSelector(selectHasInsufficientMoneyError, selectSlipErrorsFactory(slipKey), (hasInsufficientMoneyError, slipErrors) => {
        const minimumStakeErrors = (slipErrors?.filter((e) => isUnderMinimumStakeErrorPreCheck(e)) as UnderMinimumStakePreCheckError[]) ?? [];

        return {
            hasInsufficientAmountError: hasInsufficientMoneyError,
            minimumStakeErrors,
        };
    });
